module.exports = __webpack_public_path__ + "img/winner.e3be89fe.svg";